<script lang="ts">

    export let text: string;
</script>


<div on:click class="link">
    {text}
</div>


<style>
    .link {
        color: var(--analytics-red);
        cursor: pointer;
        text-decoration: underline;
        font-weight: 500;
    }
</style>

